import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Navbar from '../Layout/Navbar';
import PublicNavbar from '../Layout/PublicNavbar';
import Footer from '../Layout/Footer';
import SEO from '../Common/SEO';
import './Legal.css';

function RefundPolicy() {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'options.tracker.email.verify@gmail.com';
  const { isAuthenticated } = useAuth();
  const updatedDate = 'January 16, 2026';

  return (
    <div className="page-wrapper">
      <SEO
        title="Refund Policy"
        description="Options Tracker Refund Policy - Learn about our refund and proration policies for subscriptions."
        canonicalPath="/refund-policy"
      />
      {isAuthenticated ? <Navbar /> : <PublicNavbar />}
      <div className="container legal-page">
        <div className="page-header">
          <div>
            <h1>Refund and Proration Policy</h1>
            <p className="page-subtitle">How refunds and prorations work for Options Tracker.</p>
            <div className="legal-updated">Last updated: {updatedDate}</div>
          </div>
        </div>

        <p>
          This policy explains how refunds and prorations are handled for Options Tracker.
        </p>

        <h2>Summary</h2>
        <ul>
          <li>You can cancel at any time.</li>
          <li>You keep access until the end of your current billing period.</li>
          <li>We do not offer automatic prorated refunds for unused time.</li>
          <li>If you believe a charge was in error, contact support and we will review it.</li>
        </ul>

        <h2>Monthly Subscription</h2>
        <ul>
          <li>Billing is monthly, in advance.</li>
          <li>Cancelling stops future renewals but does not refund the current period.</li>
          <li>Access remains active until the subscription end date.</li>
        </ul>

        <h2>Free Plan</h2>
        <ul>
          <li>The Free plan provides permanent access with usage limits.</li>
          <li>You are never charged for the Free plan.</li>
          <li>Upgrade to Pro at any time for unlimited access.</li>
        </ul>

        <h2>Refunds</h2>
        <ul>
          <li>Refunds are not automatic.</li>
          <li>Refunds may be granted at our discretion (for example, duplicate charge or technical error).</li>
          <li>Refund requests must be submitted within 7 days of the charge.</li>
        </ul>

        <h2>Proration</h2>
        <ul>
          <li>Proration is not used for cancellations on monthly subscriptions.</li>
          <li>If we introduce annual plans or upgrades/downgrades in the future, this policy will be updated.</li>
        </ul>

        <h2>How to Request a Refund</h2>
        <p>
          Email support with your account email, the date and amount of the charge, and a brief
          description of the issue.
        </p>
        <p className="contact-info">
          Support: <a href={`mailto:${supportEmail}?subject=Options%20Tracker%20Refund%20Request`}>{supportEmail}</a>
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default RefundPolicy;

